import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=e6e08f44&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.less?vue&type=style&index=0&id=e6e08f44&prod&scoped=true&lang=less&external"
import style1 from "./Terms.vue?vue&type=style&index=1&id=e6e08f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e08f44",
  null
  
)

export default component.exports